import React, { useEffect, useState, useContext } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";

function ChallanCancel9() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [listData, setListData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  useEffect(() => {
    if (!permissions[6]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  const fetchChallanData = async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/FetchDataForChallancancel_CL9`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        setListData(data.data.challanCancelData_list || []);
      } else {
        console.error("API Error:", data.message);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // Fetch API data
  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchChallanData();
    }
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, [token]);

  // Search filter
  const filteredStudents = listData.filter((item) => {
    const query = searchQuery.toLowerCase();
    return (
      item.challaN_NO?.toLowerCase().includes(query) ||
      item.districT_NAME?.toLowerCase().includes(query) ||
      item.district?.toLowerCase().includes(query) ||
      item.schooL_CODE?.toLowerCase().includes(query) ||
      item.schooL_NAME?.toLowerCase().includes(query) ||
      item.nO_OF_STUDENT?.toLowerCase().includes(query) ||
      item.challaN_DATE_TIME?.toLowerCase().includes(query) ||
      item.exaM_FEES?.toLowerCase().includes(query) ||
      item.latE_FEES?.toLowerCase().includes(query)
    );
  });

  // Pagination setup
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Rows per page handler
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleCancel = async (schoolCode, challanNo) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to cancel Challan No: ${challanNo}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/ChallanCancelDataByUpdate_CL9`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                schooL_CODE: schoolCode,
                challaN_NO: challanNo,
                UPDATE_BY: sessionStorage.getItem("schoolCode") || "",
              }),
            }
          );

          const data = await response.json();
          if (response.ok) {
            Swal.fire(
              "Cancelled!",
              "Challan cancelled successfully.",
              "success"
            ).then(() => {
              fetchChallanData();
            });
          } else {
            Swal.fire(
              "Error",
              data.message || "Something went wrong.",
              "error"
            );
          }
        } catch (error) {
          console.error("Fetch error:", error);
          Swal.fire(
            "Error",
            error.message || "Network error occurred.",
            "error"
          );
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  return (
    <div className="container-scroller">
      <Navbar />
      {isLoading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <section className="content-header mb-3">
              <h1>
                <i className="fa fa-university"></i>&nbsp; Challan Cancel Class
                IX
              </h1>
              <ol className="breadcrumb">
                <li>
                  <a
                    href="#"
                    onClick={() => navigate("/secondary-admin-dashboard")}
                  >
                    Home
                  </a>
                </li>
                <li className="active"> Challan Cancel Class IX</li>
              </ol>
            </section>

            <div className="card">
              <div className="card-body">
                {/* Filters */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <label htmlFor="rowsPerPage" className="me-2 mb-0">
                      Rows:
                    </label>
                    <select
                      id="rowsPerPage"
                      className="form-select form-select-sm"
                      value={perPage}
                      onChange={handlePerPageChange}
                      style={{ width: "100px" }}
                    >
                      {[10, 20, 50, 100, 500].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ width: "200px" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                {/* Table */}
                {isLoading ? (
                  <p>Loading...</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-condensed">
                      <thead className="thead-primary">
                        <tr className="table-info">
                          <th>Sl No.</th>
                          <th>Challan No</th>
                          <th>District</th>
                          <th>School Name</th>
                          <th>Student Count</th>
                          <th>Challan Generation Date</th>
                          <th>Registration Fee</th>
                          <th>Late Fee</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No data found.
                            </td>
                          </tr>
                        ) : (
                          currentItems.map((row, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>
                                {/* <span className="badge bg-danger fw-bold"> */}
                                <span className="badge badge-danger fw-bold">
                                  {row.challaN_NO}
                                </span>
                              </td>
                              <td>
                                {row.districT_NAME} ({row.district})
                              </td>
                              <td>{row.schooL_NAME}</td>
                              <td className="text-end">{row.nO_OF_STUDENT}</td>
                              <td>{row.challaN_DATE_TIME}</td>
                              <td>{row.exaM_FEES}</td>
                              <td>{row.latE_FEES || "0.00"}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    handleCancel(
                                      row.schooL_CODE,
                                      row.challaN_NO
                                    )
                                  }
                                >
                                  <i className="fa fa-close"></i>&nbsp;Cancel
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {(currentPage - 1) * perPage + 1} to{" "}
                    {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                    {filteredStudents.length} entries
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <MdOutlineKeyboardDoubleArrowLeft
                      onClick={() => currentPage > 1 && setCurrentPage(1)}
                      style={{
                        cursor: currentPage > 1 ? "pointer" : "not-allowed",
                        opacity: currentPage > 1 ? 1 : 0.5,
                      }}
                    />
                    <MdOutlineKeyboardArrowLeft
                      onClick={() =>
                        currentPage > 1 && setCurrentPage((prev) => prev - 1)
                      }
                      style={{
                        cursor: currentPage > 1 ? "pointer" : "not-allowed",
                        opacity: currentPage > 1 ? 1 : 0.5,
                      }}
                    />
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <MdOutlineKeyboardArrowRight
                      onClick={() =>
                        currentPage < totalPages &&
                        setCurrentPage((prev) => prev + 1)
                      }
                      style={{
                        cursor:
                          currentPage < totalPages ? "pointer" : "not-allowed",
                        opacity: currentPage < totalPages ? 1 : 0.5,
                      }}
                    />
                    <MdOutlineKeyboardDoubleArrowRight
                      onClick={() =>
                        currentPage < totalPages && setCurrentPage(totalPages)
                      }
                      style={{
                        cursor:
                          currentPage < totalPages ? "pointer" : "not-allowed",
                        opacity: currentPage < totalPages ? 1 : 0.5,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default ChallanCancel9;
